module.exports = __webpack_public_path__ + "static/media/easel-empty.0545a027.png";